/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AssignOrganizationToOrganizationAdminCommand } from '../model/assignOrganizationToOrganizationAdminCommand';
import { AssignOrganizationToOrganizationAdminCommandResult } from '../model/assignOrganizationToOrganizationAdminCommandResult';
import { ChangeOrganizationAdminActiveOrganizationCommand } from '../model/changeOrganizationAdminActiveOrganizationCommand';
import { ChangeOrganizationAdminStatusCommand } from '../model/changeOrganizationAdminStatusCommand';
import { CreateOrganizationAdminCommand } from '../model/createOrganizationAdminCommand';
import { CreateOrganizationAdminCommandResult } from '../model/createOrganizationAdminCommandResult';
import { GetOrganizationAdminOrganizationsQueryResult } from '../model/getOrganizationAdminOrganizationsQueryResult';
import { GetOrganizationAdminsQueryResult } from '../model/getOrganizationAdminsQueryResult';
import { GetOtherOrganizationAdminsQueryResult } from '../model/getOtherOrganizationAdminsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { OrganizationAdminsSortSpecification } from '../model/organizationAdminsSortSpecification';
import { UnassignOrganizationFromOrganizationAdminCommandResult } from '../model/unassignOrganizationFromOrganizationAdminCommandResult';
import { UpdateOrganizationAdminCommand } from '../model/updateOrganizationAdminCommand';
import { UserStatusType } from '../model/userStatusType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OrganizationAdminsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * List organization admins (scoped)
     * Returns a paginated list of admins for a specific organization. OrganizationAdmins are automatically scoped to their own organization; SuperAdmins can supply an organizationUid.
     * @param organizationUid 
     * @param status 
     * @param sort 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsGet(organizationUid?: string, status?: UserStatusType, sort?: Array<OrganizationAdminsSortSpecification>, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetOrganizationAdminsQueryResult>;
    public organizationAdminsGet(organizationUid?: string, status?: UserStatusType, sort?: Array<OrganizationAdminsSortSpecification>, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetOrganizationAdminsQueryResult>>;
    public organizationAdminsGet(organizationUid?: string, status?: UserStatusType, sort?: Array<OrganizationAdminsSortSpecification>, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetOrganizationAdminsQueryResult>>;
    public organizationAdminsGet(organizationUid?: string, status?: UserStatusType, sort?: Array<OrganizationAdminsSortSpecification>, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (organizationUid !== undefined && organizationUid !== null) {
            queryParameters = queryParameters.set('OrganizationUid', <any>organizationUid);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('Sort', <any>element);
            })
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetOrganizationAdminsQueryResult>('get',`${this.basePath}/OrganizationAdmins`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List admins in other organizations
     * Returns a paginated list of all organization admins excluding those already belonging to the provided organizationUid. SuperAdmin only.
     * @param organizationUid 
     * @param status 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsOthersGet(organizationUid?: string, status?: UserStatusType, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetOtherOrganizationAdminsQueryResult>;
    public organizationAdminsOthersGet(organizationUid?: string, status?: UserStatusType, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetOtherOrganizationAdminsQueryResult>>;
    public organizationAdminsOthersGet(organizationUid?: string, status?: UserStatusType, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetOtherOrganizationAdminsQueryResult>>;
    public organizationAdminsOthersGet(organizationUid?: string, status?: UserStatusType, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (organizationUid !== undefined && organizationUid !== null) {
            queryParameters = queryParameters.set('OrganizationUid', <any>organizationUid);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetOtherOrganizationAdminsQueryResult>('get',`${this.basePath}/OrganizationAdmins/Others`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create organization admin
     * Creates a new organization admin within the specified organization. Requires SuperAdmin or OrganizationAdmin (for their own organization).
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsPost(body?: CreateOrganizationAdminCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateOrganizationAdminCommandResult>;
    public organizationAdminsPost(body?: CreateOrganizationAdminCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateOrganizationAdminCommandResult>>;
    public organizationAdminsPost(body?: CreateOrganizationAdminCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateOrganizationAdminCommandResult>>;
    public organizationAdminsPost(body?: CreateOrganizationAdminCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateOrganizationAdminCommandResult>('post',`${this.basePath}/OrganizationAdmins`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change active organization
     * Sets which organization is currently active for the specified admin (when belonging to multiple organizations).
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsUidActiveOrganizationPatch(uid: string, body?: ChangeOrganizationAdminActiveOrganizationCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public organizationAdminsUidActiveOrganizationPatch(uid: string, body?: ChangeOrganizationAdminActiveOrganizationCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public organizationAdminsUidActiveOrganizationPatch(uid: string, body?: ChangeOrganizationAdminActiveOrganizationCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public organizationAdminsUidActiveOrganizationPatch(uid: string, body?: ChangeOrganizationAdminActiveOrganizationCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling organizationAdminsUidActiveOrganizationPatch.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/OrganizationAdmins/${encodeURIComponent(String(uid))}/ActiveOrganization`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assign organization to admin
     * Assigns an additional organization to the specified organization admin. SuperAdmin only.
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsUidAssignOrganizationPost(uid: string, body?: AssignOrganizationToOrganizationAdminCommand, observe?: 'body', reportProgress?: boolean): Observable<AssignOrganizationToOrganizationAdminCommandResult>;
    public organizationAdminsUidAssignOrganizationPost(uid: string, body?: AssignOrganizationToOrganizationAdminCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssignOrganizationToOrganizationAdminCommandResult>>;
    public organizationAdminsUidAssignOrganizationPost(uid: string, body?: AssignOrganizationToOrganizationAdminCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssignOrganizationToOrganizationAdminCommandResult>>;
    public organizationAdminsUidAssignOrganizationPost(uid: string, body?: AssignOrganizationToOrganizationAdminCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling organizationAdminsUidAssignOrganizationPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AssignOrganizationToOrganizationAdminCommandResult>('post',`${this.basePath}/OrganizationAdmins/${encodeURIComponent(String(uid))}/AssignOrganization`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List admin organizations
     * Returns the organizations associated with the specified admin (multi-org scenarios).
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsUidOrganizationsGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetOrganizationAdminOrganizationsQueryResult>;
    public organizationAdminsUidOrganizationsGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetOrganizationAdminOrganizationsQueryResult>>;
    public organizationAdminsUidOrganizationsGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetOrganizationAdminOrganizationsQueryResult>>;
    public organizationAdminsUidOrganizationsGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling organizationAdminsUidOrganizationsGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetOrganizationAdminOrganizationsQueryResult>('get',`${this.basePath}/OrganizationAdmins/${encodeURIComponent(String(uid))}/Organizations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unassign organization from admin
     * Removes the association between the specified organization and organization admin. SuperAdmin only.
     * @param uid 
     * @param organizationUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsUidOrganizationsOrganizationUidDelete(uid: string, organizationUid: string, observe?: 'body', reportProgress?: boolean): Observable<UnassignOrganizationFromOrganizationAdminCommandResult>;
    public organizationAdminsUidOrganizationsOrganizationUidDelete(uid: string, organizationUid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UnassignOrganizationFromOrganizationAdminCommandResult>>;
    public organizationAdminsUidOrganizationsOrganizationUidDelete(uid: string, organizationUid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UnassignOrganizationFromOrganizationAdminCommandResult>>;
    public organizationAdminsUidOrganizationsOrganizationUidDelete(uid: string, organizationUid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling organizationAdminsUidOrganizationsOrganizationUidDelete.');
        }

        if (organizationUid === null || organizationUid === undefined) {
            throw new Error('Required parameter organizationUid was null or undefined when calling organizationAdminsUidOrganizationsOrganizationUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UnassignOrganizationFromOrganizationAdminCommandResult>('delete',`${this.basePath}/OrganizationAdmins/${encodeURIComponent(String(uid))}/Organizations/${encodeURIComponent(String(organizationUid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update organization admin
     * Updates profile information for the specified organization admin.
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsUidPut(uid: string, body?: UpdateOrganizationAdminCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public organizationAdminsUidPut(uid: string, body?: UpdateOrganizationAdminCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public organizationAdminsUidPut(uid: string, body?: UpdateOrganizationAdminCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public organizationAdminsUidPut(uid: string, body?: UpdateOrganizationAdminCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling organizationAdminsUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/OrganizationAdmins/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change admin status
     * Changes the status (Active/Inactive/etc.) of the specified organization admin.
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public organizationAdminsUidStatusPut(uid: string, body?: ChangeOrganizationAdminStatusCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public organizationAdminsUidStatusPut(uid: string, body?: ChangeOrganizationAdminStatusCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public organizationAdminsUidStatusPut(uid: string, body?: ChangeOrganizationAdminStatusCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public organizationAdminsUidStatusPut(uid: string, body?: ChangeOrganizationAdminStatusCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling organizationAdminsUidStatusPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/OrganizationAdmins/${encodeURIComponent(String(uid))}/Status`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
